import { useSuspenseQuery } from "@tanstack/react-query";

import { VoucherAssignmentQueries } from "../Checkout/VoucherAssignments/queries";
import { CartQueries } from "./queries";

export const useCartTotals = (cartUuid: string) => {
  const subTotal = useSuspenseQuery(CartQueries.cartTotal(cartUuid)).data;
  const totalVoucherValue = useSuspenseQuery(
    VoucherAssignmentQueries.totalAssignmentValue(cartUuid),
  ).data;
  const maxVoucherApplied = Math.min(subTotal, totalVoucherValue);
  const totalDue = subTotal - maxVoucherApplied;
  const remainingVoucherTotal = totalVoucherValue - maxVoucherApplied;
  return {
    totalVoucherValue,
    subTotal: subTotal,
    voucherTotalApplied: maxVoucherApplied,
    remainingVoucherTotal,
    totalDue,
  };
};
